import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';
import Icon from '../../../components/AppIcon';

const AttendanceTrendsChart = ({ data }) => {
  const formatDate = (dateStr) => {
    return format(new Date(dateStr), 'MMM dd');
  };

  if (!data || data?.length === 0) {
    return (
      <div className="bg-card rounded-xl shadow-md p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Attendance Trends</h2>
        <div className="flex flex-col items-center justify-center py-12">
          <Icon name="TrendingUp" size={48} className="text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No attendance data available for the selected period</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Attendance Trends</h2>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Info" size={16} />
          <span>Daily attendance patterns</span>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis
            dataKey="date"
            tickFormatter={formatDate}
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <YAxis
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <Tooltip
            labelFormatter={(label) => format(new Date(label), 'MMMM dd, yyyy')}
            contentStyle={{
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-border)',
              borderRadius: '8px',
              color: 'var(--color-foreground)'
            }}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="visits"
            name="Total Visits"
            stroke="var(--color-primary)"
            strokeWidth={2}
            dot={{ fill: 'var(--color-primary)', r: 4 }}
            activeDot={{ r: 6 }}
          />
          <Line
            type="monotone"
            dataKey="uniqueMembers"
            name="Unique Members"
            stroke="var(--color-success)"
            strokeWidth={2}
            dot={{ fill: 'var(--color-success)', r: 4 }}
            activeDot={{ r: 6 }}
          />
          <Line
            type="monotone"
            dataKey="avgDuration"
            name="Avg Duration (min)"
            stroke="var(--color-warning)"
            strokeWidth={2}
            dot={{ fill: 'var(--color-warning)', r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AttendanceTrendsChart;